import React, { useState } from "react";

import Table from "../../../../../components/table-simple/table";
import { Button } from "../../../../../components/buttons";
import LoaderSpinner from "../../../../../components/loader-spinner";
import { images } from "../../../../../assets";
import { RenewalPoliciesContainer } from "./renewal-policies-dashboard-style";
import ClientsDashboardServices from "../../../../../services/ClientsDashboardServices";
import { convertBase64ToFile, downloadBlob } from "../../../../../utils/utility";
import { formatRenewalTableData } from "./helpers";
import LeftInfoModal from "../../../../../components/left-info-modal";
import NoData from "../../common-components/no-data";
import { IGetUpcomingRenewalData } from "../../../../../services/ClientsDashboardServices.dto";
import { UseMediatorDataError } from "../../hooks/useGetMediatorData-types";

interface RenewalPoliciesProps {
  mediatorCode: string;
  data: IGetUpcomingRenewalData | null;
  error: UseMediatorDataError;
}

const RenewalPolicies = ({ data, mediatorCode, error: serverError }: RenewalPoliciesProps) => {
  const renewalTableData = formatRenewalTableData(data);
  const [loading, setLoading] = useState<boolean>(false);
  const [downloadError, setDownloadError] = useState<string>("");

  const handleDownload = async () => {
    setLoading(true);

    const response = await ClientsDashboardServices.downloadUpcomingRenewals({
      setLoading: () => {},
      loader: false,
      mediatorCode,
    });
    if (response.ok) {
      const { content, metadata } = response.data;
      downloadBlob(convertBase64ToFile(content, "csv"), metadata.name);
    } else {
      setDownloadError(response.message);
    }

    setLoading(false);
  };

  if (serverError.renewal) {
    return <NoData message={serverError.renewal} />;
  }

  return (
    <RenewalPoliciesContainer>
      {renewalTableData ? (
        <>
          <Table columns={renewalTableData.columns} data={renewalTableData.tableData} />

          <div className="button-container">
            {loading ? (
              <LoaderSpinner />
            ) : (
              <Button text="Exportar datos" disabled={loading} onClick={handleDownload} />
            )}
          </div>
        </>
      ) : (
        <NoData message="No existen datos." />
      )}
      <LeftInfoModal
        img={images.IconWarningYellow}
        className="warning"
        mainTitle="Error"
        mainText={downloadError}
        buttonText="Cerrar"
        active={downloadError}
        onClickAccept={() => setDownloadError("")}
        close={() => setDownloadError("")}
        noSecondaryButton
      />
    </RenewalPoliciesContainer>
  );
};

export default RenewalPolicies;
